<template>
    <div>
        <div class="loader" v-if="saving"></div>
        <div class="col-12 mx-auto row" v-if="!saving">
            <div class="row form-group col-sm-12 col-md-12">
                <div class="btn-group col-sm-12 col-md-3" role="group">
                    <button type="button"
                            v-if="!isNaN(relatedId) && relatedId > 0"
                            class="btn btn-primary"
                            @click="redirectToRelatedEvent">
                        <i class="fas fa-calendar-check"></i> {{ $t('backToRelatedEvent') }}
                    </button>
                    <button type="button"
                            class="btn btn-primary"
                            @click="redirectToList">
                        <i class="fas fa-th-list"></i> {{ $t('backToFormsList') }}
                    </button>
                </div>
                <div class="col-sm-12 col-md-8 mt-2">
                    <page-title :title="$t('registers.forms.title') + ( isCopy ? ' / ' + $t('buttons.copy.btnText') : ( isNew ? ' / ' + $t('buttons.create.btnText') : (readonly ? ' / ' + $t('buttons.details.btnText') : ' / ' + $t('buttons.edit.btnText'))))"></page-title>
                </div>
            </div>

            <div class="form-group col-md-6 col-sm-12">
                <label class="font-weight-bold required" :for="'formName' + _uid"> {{ $t('registers.forms.editor.name') }} </label>
                <input type="text" class="form-control"
                       v-model="form.name"
                       :data-vv-as="$t('registers.forms.editor.name')"
                       v-validate="'required'"
                       :disabled="readonly"
                       :name="'formName' + _uid"
                       :id="'formName' + _uid">
                <span class="text-danger" v-if="errors.has('formName' + _uid)">{{ errors.first('formName' + _uid) }}</span>
            </div>
            <div class="form-group col-md-6 col-sm-12">
                <label class="font-weight-bold" :for="'formNameEn' + _uid"> {{ $t('registers.forms.editor.nameEn') }} </label>
                <input type="text" class="form-control"
                       v-model="form.nameEn"
                       :disabled="readonly"
                       :name="'formNameEn' + _uid"
                       :id="'formNameEn' + _uid">
            </div>

            <div class="form-group col-md-6 col-sm-12">
                <label class="font-weight-bold" :class="relatedEventRequired ? 'required' : ''" :for="'formEvent' + _uid"> {{ $t('registers.forms.editor.relatedEvent') }} </label>
                <DynamicMultiSelect :apiUrl="`/api/dynamicRegisters/eventsDropdowns`"
                                    v-model="form.registerEntities"
                                    :name="'formEvent' + _uid"
                                    :id="'formEvent' + _uid"
                                    :optionLabel="$t('select')"
                                    :required="relatedEventRequired"
                                    :data-vv-as="$t('registers.forms.editor.relatedEvent')"
                                    :fieldName="$t('registers.forms.editor.relatedEvent')"
                                    aria-describedby="relatedEventHelp">
                </DynamicMultiSelect>
                <small id="relatedEventHelp" class="form-text text-muted">{{ $t('registers.forms.editor.helps.relatedEvent') }}</small>
            </div>

            <div class="form-group col-md-6 col-sm-12">
                <label class="font-weight-bold required" :for="'formType' + _uid">{{ $t('registers.forms.editor.formType') }}</label>
                <dropdown :type="'Тип на формуляр'"
                          :load-by-parent-sort="true"
                          :parent-sort="nomenclature.FormType"
                          v-model="form.formTypeId"
                          :required="true"
                          :name="'formType' + _uid"
                          :id="'formType' + _uid"
                          :fieldName="$t('registers.forms.editor.formType')">
                </dropdown>
            </div>

            <div class="form-group col-md-3 col-sm-6">
                <label class="font-weight-bold" :for="'fromIsTemplate' + _uid"> {{ $t('registers.forms.editor.useAsTemplate') }} </label>
                <toggled-btn v-model="form.isTemplate"
                             :sync="true"
                             :name="'fromIsTemplate' + _uid"
                             :id="'fromIsTemplate' + _uid"
                             :disabled="readonly || !claims.formSurveyTemplate.create">
                </toggled-btn>
            </div>

            <div class="form-group col-md-3 col-sm-6">
                <label class="font-weight-bold" :for="'deactivated' + _uid"> {{ $t('registers.forms.editor.deactivate') }} </label>
                <toggled-btn v-model="form.deactivated"
                             :sync="true"
                             :name="'deactivated' + _uid"
                             :id="'deactivated' + _uid"
                             :disabled="readonly">
                </toggled-btn>
            </div>

            <div class="form-group col-md-6 col-sm-12">
                <label class="font-weight-bold" :for="'formNote' + _uid"> {{ $t('registers.forms.editor.note') }} </label>
                <textarea rows="3" class="form-control"
                          v-model="form.note"
                          :name="'formNote' + _uid"
                          :id="'formNote' + _uid"
                          :disabled="readonly">
                </textarea>
            </div>


            <div class="form-group col-12">
                <label class="col-form-label font-weight-bold" :for="'header' + _uid"> {{ $t('registers.forms.editor.header') }} </label>
                <kendo-editor v-model="form.header"
                              :resizable-content="true"
                              :resizable-toolbar="true"
                              :id="'header' + _uid"
                              :name="'header' + _uid"
                              style="min-height:300px"
                              rows="15"
                              cols="30">
                </kendo-editor>
            </div>

            <div class="form-group col-12">
                <label class="col-form-label font-weight-bold" :for="'footer' + _uid"> {{ $t('registers.forms.editor.footer') }} </label>
                <kendo-editor v-model="form.footer"
                              :resizable-content="true"
                              :resizable-toolbar="true"
                              :id="'footer' + _uid"
                              :name="'footer' + _uid"
                              style="min-height:300px"
                              rows="15"
                              cols="30">
                </kendo-editor>
            </div>

            <div class="form-group col-12 mt-3 mb-0" v-if="!readonly">
                <button type="button" class="btn btn-lg btn-primary"
                        :disabled="saving"
                        @click="onSubmit">
                    <i class="fa fa-save"></i>
                    {{ $t('save') }}
                </button>
            </div>
        </div>

        <div>
            <div class="row mt-5 mx-5">
                <div class="col-md-8 dragArea pb-5" @drop="droppedInRoot" @dragover.prevent="dragOver">
                    <draggable v-model="form.panels" @start="draggableDragStart" @end="draggableDragEnd" :options="{animation:150}">
                        <transition-group name="panelDragAnimation" enter-active-class="animated lightSpeedIn">
                            <div class="dropitem"
                                 v-for="(panel, index) in form.panels"
                                 :key="panel.sort"
                                 @drop.prevent="droppedInPanel(index, $event)">
                                <panel :panel="panel"
                                       :components="panel.components"
                                       :isFormField="true"
                                       :isAuxRegisterField="false"
                                       :isEventFieldCode="false"
                                       draggable="true"
                                       @dragging="dragging = $event">
                                </panel>
                            </div>
                        </transition-group>
                    </draggable>
                </div>
                <div class="col-md-4">
                    <div class="card sticky-top" v-if="!dragging">
                        <div class="card-header bg-info text-white">
                            <div class="card-title h5 m-0"> Tools <i class="fas fa-tools float-right"></i></div>
                        </div>
                        <div class="card-body" v-if="!readonly">
                            <div class="panel pointer" draggable="true" @dragstart="onDragStart" data-type="panel">{{ $t('editor.tools.panel') }}</div>
                            <div class="input pointer mt-2" draggable="true" @dragstart="onDragStart" data-type="Input">{{ $t('editor.tools.textbox') }}</div>
                            <div class="input pointer mt-2" draggable="true" @dragstart="onDragStart" data-type="Datepicker">{{ $t('editor.tools.datepicker') }}</div>
                            <div class="input pointer mt-2" draggable="true" @dragstart="onDragStart" data-type="Dropdown">{{ $t('editor.tools.dropdown') }}</div>
                            <div class="input pointer mt-2" draggable="true" @dragstart="onDragStart" data-type="Toggle">{{ $t('editor.tools.toggle') }}</div>
                            <div class="input pointer mt-2" draggable="true" @dragstart="onDragStart" data-type="PersonIdentification">{{ $t('editor.tools.personIdentification') }}</div>
                            <div class="input pointer mt-2" draggable="true" @dragstart="onDragStart" data-type="FileUpload">{{ $t('editor.tools.fileUpload') }}</div>
                            <div class="input pointer mt-2" draggable="true" @dragstart="onDragStart" data-type="Person">{{ $t('editor.tools.person') }}</div>
                            <div class="input pointer mt-2" draggable="true" @dragstart="onDragStart" data-type="Address">{{ $t('editor.tools.address') }}</div>
                            <div class="input pointer mt-2" draggable="true" @dragstart="onDragStart" data-type="StarRating">{{ $t('editor.tools.startRating') }}</div>
                            <div class="input pointer mt-2" draggable="true" @dragstart="onDragStart" data-type="Evaluation">{{ $t('editor.tools.evaluate') }}</div>
                        </div>
                    </div>

                    <draggable v-model="trashZone" class="dropzone trashzone sticky-top" :options="trashOptions">
                        <div class="card sticky-bottom" v-if="dragging">
                            <div class="card-header bg-danger text-white">
                                <div class="card-title h5 m-0">{{ $t('buttons.delete.btnText') }}</div>
                            </div>
                            <div class="card-body text-center py-5">
                                <i class="fa fa-trash-alt fa-9x text-danger"></i>
                            </div>
                        </div>
                    </draggable>
                </div>

                <div class="form-group mt-3" v-if="!readonly">
                    <button type="button" class="btn btn-lg btn-primary"
                            :disabled="saving"
                            @click="onSubmit">
                        <i class="fa fa-save"></i>
                        {{ $t('save') }}
                    </button>
                </div>

                <div v-if="validationErrors">
                    <br />
                    <br />
                    <h4 class="text-danger">
                        {{validationErrors}}
                    </h4>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import Panel from '../../components/editor/Panel';
    import { EditorComponentModel, EditorPanel, EditorForms } from '../../models/models';
    import {
        ComponentSize,
        NomenclatureParentBySort
    } from '../../models/enums';
    import Draggable from 'vuedraggable';
    import PageTitle from '../../components/common/PageTitle';
    import ToggledBtn from '../../components/toggle/Toggle';
    import Dropdown from '../../components/dropdown/NomenclatureDropdown';
    import DynamicMultiSelect from '../../components/dropdown/DynamicMultiSelect';
    import actionLogService from '../../services/actionLog.service';
    import { mapGetters } from 'vuex'

    import { EditorInstaller } from '@progress/kendo-editor-vue-wrapper'
import { readonly } from 'vue';

    Vue.use(EditorInstaller)

    export default {
        inject: ['$validator'],
        props: {
            id: Number,
            isCopy: {
                type: Boolean,
                default: false
            },
            relatedId: {
                type: Number,
                default: 0
            },
            defaultValidFrom: {
                type: Date,
                default: () => new Date()
            },
            defaultValidTo: {
                type: Date,
                default: () => (new Date()).addDays(7)
            },
            eventId: {
                type: Number,
                default: 0
            },
            readonly: {
                type: Boolean,
                default: false
            },
            returnUrl: {
                type: String
            }
        },
        components: {
            'panel': Panel,
            'toggled-btn': ToggledBtn,
            Draggable,
            PageTitle,
            Dropdown,
            DynamicMultiSelect
        },
        data() {
            return {
                nomenclature: NomenclatureParentBySort,
                saving: false,
                formLoaded: false,
                currentPanelSort: 1,
                currentComponentSort: 1,
                panelId: 1,
                form: new EditorForms(),
                dragging: false,
                trashZone: [],
                trashOptions: {
                    group: {
                        name: 'trash',
                        draggable: '.dropitem',
                        put: () => true,
                        pull: false
                    }
                },
                validationErrors: '',
                datePickerItem: {},
            }
        },
        mounted: function () {
            if (!this.isNew && !this.isCopy) {
                this.load()
            } else if (this.isCopy) {
                this.loadForCopy()
            } else {
                this.form.validFromUtc = this.defaultValidFrom
                this.form.validToUtc = this.defaultValidTo

                if (!isNaN(this.relatedId)) {
                    this.form.registerEntityId = this.relatedId

                    // По подразбиране е true. По задание, ако е false независимо от
                    // датите на валидност става активен за попълване.
                    this.form.deactivated = true;
                }

                this.formLoaded = true;
            }
        },
        computed: {
            ...mapGetters(['claims']),
            isNew: function () {
                return this.isCopy || this.id === undefined;
            },
            isBgCulture() {
                return this.$store.getters.currentCulture === Culture.BG;
            },
            relatedEventRequired() {
                if (!this.form || this.form.isTemplate) {
                    return false;
                }

                return true;
            }
        },
        methods: {
            droppedInRoot(event) {
                const componentType = event.dataTransfer.getData('componentType');
                if (componentType === 'panel' || componentType === 'Evaluation') {
                    this.form.panels.push(new EditorPanel({
                        name: componentType === 'Evaluation' ? 'Оценка' + new Date().getMilliseconds() : 'Първоначално име',
                        nameEn: componentType === 'Evaluation' ? 'Evaluation' + new Date().getMilliseconds() : 'Initial name',
                        label: componentType === 'Evaluation' ? 'Име на участник' : 'Първоначален етикет',
                        labelEn: componentType === 'Evaluation' ? 'Participant name' : 'Initial label',
                        sort: this.currentPanelSort++, // TODO:
                        isEvaluationPanel: componentType === 'Evaluation',
                        components: []
                    }));
                }
            },
            onDragStart(event) {
                event.dataTransfer.dropEffect = 'copy';
                const componentType = event.target.dataset['type'];
                event.dataTransfer.setData('componentType', componentType);
            },
            dragOver(event) {
                // console.log(event);
            },
            draggableDragStart() {
                this.drag = true;
                this.dragging = true;
            },
            draggableDragEnd() {
                this.drag = false;
                this.dragging = false;
            },
            droppedInPanel(index, event) {
                event.stopPropagation();
                const componentType = event.dataTransfer.getData('componentType');
                if (componentType !== 'panel' && componentType !== '' && componentType !== 'Evaluation') {
                    this.form.panels[index].components.push(new EditorComponentModel({
                        fieldType: componentType,
                        name: 'Първоначално име',
                        nameEn: 'Initial name',
                        label: 'Първоначален етикет', // this.$t('editor.panel.initialComponentLabel'),
                        labelEn: 'Initial label',
                        sort: this.currentComponentSort++,
                        size: ComponentSize.Medium
                    }));
                }
            },
            onSubmit() {
                this.$validator.validateAll().then(result => {
                    if (result) {
                        this.saving = true;
                        this.validationErrors = '';

                        this.setSort();

                        if (this.isNew) {
                            this.$http.post('/api/dynamicForms',
                                this.form
                            ).then(response => {
                                this.saving = false;
                                this.$vs.notify({
                                    title: response.request ? this.$t('request.response.status.' + response.request.status) : this.$t('request.response.status.200'),
                                    text: response.data.message ? response.data.message : (response.request.statusText ? response.request.statusText : response.message),
                                    color: 'success',
                                    time: this.$store.getters.notificationDuration,
                                });

                                this.redirectToList();
                            }).catch(error => {
                                this.saving = false;

                                this.$vs.notify({
                                    title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                                    text: this.$helpers.errorText(error),
                                    color: 'danger',
                                    time: this.$store.getters.notificationDuration
                                })

                                if (error.response.data.validationErrors) {
                                    this.validationErrors = error.response.data.validationErrors;
                                }
                            });
                        } else {
                            this.$http.put('/api/dynamicForms/update',
                                this.form
                            ).then(response => {
                                this.saving = false;
                                this.$vs.notify({
                                    title: response.request ? this.$t('request.response.status.' + response.request.status) : this.$t('request.response.status.200'),
                                    text: response.data.message ? response.data.message : (response.request.statusText ? response.request.statusText : response.message),
                                    color: 'success',
                                    time: this.$store.getters.notificationDuration,
                                });

                                this.redirectToList();
                            }).catch(error => {
                                this.saving = false;

                                this.$vs.notify({
                                    title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                                    text: this.$helpers.errorText(error),
                                    color: 'danger',
                                    time: this.$store.getters.notificationDuration
                                })

                                if (error.response.data.validationErrors) {
                                    this.validationErrors = error.response.data.validationErrors;
                                }
                            });
                        }
                    }
                });
            },
            setSort() {
                let panelSort = 1;
                this.form.panels.forEach(panel => {
                    panel.sort = panelSort++;
                    let componentSort = 1;
                    panel.components.forEach(component => {
                        component.sort = componentSort++;
                        component.fieldValue = null;
                    });
                });
            },
            load() {
                this.$http.get('/api/dynamicForms/' + this.id + '/formStructure')
                    .then(response => {
                        this.formLoaded = true;
                        this.form = new EditorForms(response.data);
                        actionLogService.formSchemaOpenForEdit(this.id);
                    }).catch(error => {
                        this.formLoaded = true;
                        this.saving = false;

                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        });
                    });
            },
            loadForCopy() {
                this.$http.get('/api/dynamicForms/formStructureCopy', { params: { id: this.id, eventId: this.eventId } })
                    .then(response => {
                        this.formLoaded = true;
                        this.form = new EditorForms(response.data);
                    }).catch(error => {
                        this.formLoaded = true;
                        this.saving = false;

                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        });
                    });
            },
            redirectToList() {
                if (this.isCopy && !isNaN(this.eventId) && this.eventId > 0) {
                    this.$router.push({ path: `/registers/events/edit/${this.eventId}` });
                } else {
                    if (this.returnUrl) {
                        this.$router.push({ path: this.returnUrl });
                    } else {
                        this.$router.push({ path: '/forms' });
                    }
                }
            },
            redirectToRelatedEvent() {
                this.$router.push({ path: `/registers/events/edit/${this.relatedId}` });
            },
            startChange(e) {
                let startDate = this.form.validFromUtc;
                let endDate = this.form.validToUtc;

                if (startDate) {
                    startDate = new Date(startDate);
                    startDate.setDate(startDate.getDate());

                    this.datePickerItem.endMinDate = startDate;
                } else if (endDate) {
                    this.datePickerItem.startMaxDate = new Date(endDate);
                } else {
                    endDate = new Date();
                    this.datePickerItem.startMaxDate = endDate;
                    this.datePickerItem.endMinDate = endDate;
                }
            },
            endChange(e) {
                let startDate = this.form.validFromUtc;
                let endDate = this.form.validToUtc;

                if (endDate) {
                    endDate = new Date(endDate);
                    endDate.setDate(endDate.getDate());

                    this.datePickerItem.startMaxDate = endDate;
                } else if (startDate) {
                    this.datePickerItem.endMinDate = new Date(startDate);
                } else {
                    endDate = new Date();
                    this.datePickerItem.startMaxDate = endDate;
                    this.datePickerItem.endMinDate = new Date(startDate);
                }
            },
        }
    }
</script>

<style scoped>
    .panel {
        border: 1px solid #3498db;
        border-radius: 3px;
        padding: 10px;
    }

    .input {
        border: 1px solid #009688;
        border-radius: 3px;
        padding: 10px;
    }

    .dragArea {
        background: #ccc;
        /*opacity: 0.5;*/
    }

    .pointer {
        cursor: pointer;
    }

    .trashzone .dropitem {
        display: none;
    }
</style>
